<template>
  <Loader :loading="httpSend">
    <div class="mt-3" v-if="declaracao.periodo > 0">
      <div class="row mt-2">
        <div class="col-sm-12">
          <b-card no-body class="mb-1 border border-info shadow-none">
            <b-card-header class="bg-info" header-tag="header">
              <h6 class="m-0 text-white">
                Informações do Contribuinte
              </h6>
            </b-card-header>
            <b-card-body>
              <b-card-text>
                <div class="row">
                  <dl class="col-md-3">
                    <dt class="text-dark">CNPJ</dt>
                    <dd>{{ declaracao.cnpj | VMask('##.###.###/####-##') }}</dd>
                  </dl>
                  <dl class="col-md-9">
                    <dt class="text-dark">Nome Empresarial</dt>
                    <dd>{{ declaracao.razao_social }}</dd>
                  </dl>
                </div>
                <div class="row">
                  <dl class="col-md-3">
                    <dt class="text-dark">Data de Abertura no CNPJ</dt>
                    <dd>{{ declaracao.abertura | formatDataSimples }}</dd>
                  </dl>
                  <dl class="col-md-3">
                    <dt class="text-dark">Regime de Apuração</dt>
                    <dd>{{ (declaracao.regime === 1) ? 'Caixa' : 'Competência' }}</dd>
                  </dl>
                  <dl class="col-md-3">
                    <dt class="text-dark">Optante pelo Simples Nacional</dt>
                    <dd>{{ declaracao.optante ? 'Sim' : 'Não' }}</dd>
                  </dl>
                  <dl class="col-md-3">
                    <dt class="text-dark">Município</dt>
                    <dd>{{ declaracao.mun_codigo.mun_nome + ' - ' + declaracao.mun_codigo.mun_uf }}</dd>
                  </dl>
                </div>
              </b-card-text>
            </b-card-body>
          </b-card>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-sm-12">
          <b-card no-body class="mb-1 border border-info shadow-none">
            <b-card-header class="bg-info" header-tag="header">
              <h6 class="m-0 text-white">
                Informações da Apuração
              </h6>
            </b-card-header>
            <b-card-body>
              <b-card-text>
                <div class="row">
                  <dl class="col-md-3">
                    <dt class="text-dark">Número</dt>
                    <dd>{{ declaracao.numero_declaracao }}</dd>
                  </dl>
                  <dl class="col-md-3">
                    <dt class="text-dark">Data da Transmissão</dt>
                    <dd>{{ declaracao.data_trasmissao | formatDataHoraSimples }}</dd>
                  </dl>
                  <dl class="col-md-3">
                    <dt class="text-dark">Tipo</dt>
                    <dd v-if="!declaracao.retificacao"><span class="badge badge-soft-success">Original</span></dd>
                    <dd v-else><span class="badge badge-soft-danger">Retificada</span></dd>
                  </dl>
                  <div class="w-100"></div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <h6 class="mb-3">Total da Receitas Brutas</h6>
                    <table class="table">
                      <thead>
                      <tr>
                        <td></td>
                        <td class="text-right text-dark font-weight-bold">Interno</td>
                        <td class="text-right text-dark font-weight-bold">Externo</td>
                        <td class="text-right text-dark font-weight-bold">Total</td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>Período da Apuração ({{ declaracao.periodo }})</td>
                        <td class="text-right">{{ declaracao.rpa_int  | formatNumeroBr }}</td>
                        <td class="text-right">R$&nbsp;0,00</td>
                        <td class="text-right">{{ declaracao.receita  | formatNumeroBr }}</td>
                      </tr>
                      <tr>
                        <td>Receita bruta acumulada nos doze meses anteriores ao período da apuração</td>
                        <td class="text-right">{{ declaracao.receita_periodos_anteriores.rbt12_int | formatNumeroBr }}</td>
                        <td class="text-right">R$&nbsp;0,00</td>
                        <td class="text-right">{{ declaracao.receita_periodos_anteriores.rbt12 | formatNumeroBr }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-card-text>
            </b-card-body>
          </b-card>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-sm-12">
          <b-card no-body class="mb-1 border border-info shadow-none">
            <b-card-header class="bg-info" header-tag="header">
              <h6 class="m-0 text-white">
                Valores Fixos
              </h6>
            </b-card-header>
            <b-card-body>
              <b-card-text>
                <div class="row">
                  <div class="col-sm-4 mb-2">
                    <div
                        class="rounded d-flex flex-column justify-content-between align-items-center pt-4 pb-4 alert-secondary">
                      <div class="text-muted">ICMS</div>
                      <div class="text-dark pt-2 pr-3 pb-2 pl-3 rounded">
                        <strong>{{ declaracao.receita_periodos_anteriores.icms | formatNumeroBr }}</strong></div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div
                        class="rounded d-flex flex-column justify-content-between align-items-center pt-4 pb-4 alert-secondary">
                      <div class="text-muted">ISS</div>
                      <div class="text-dark pt-2 pr-3 pb-2 pl-3 rounded">
                        <strong>{{ declaracao.receita_periodos_anteriores.iss | formatNumeroBr }}</strong></div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div
                        class="rounded d-flex flex-column justify-content-between align-items-center pt-4 pb-4 alert-secondary">
                      <div class="text-muted">Total</div>
                      <div class="text-dark pt-2 pr-3 pb-2 pl-3 rounded">
                        <strong>{{
                            (declaracao.receita_periodos_anteriores.icms + declaracao.receita_periodos_anteriores.iss) | formatNumeroBr
                          }}</strong></div>
                    </div>
                  </div>
                </div>
              </b-card-text>
            </b-card-body>
          </b-card>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-sm-12">
          <b-card no-body class="mb-1 border border-info shadow-none">
            <b-card-header class="bg-info" header-tag="header">
              <h6 class="m-0 text-white">
                Informações dos Estabelecimentos
              </h6>
            </b-card-header>
            <b-card-body>
              <b-card-text>
                <div class="row">
                  <div class="col-sm-12">
                    <b-card v-for="d in declaracao.filial" v-bind:key="d.cnpj" no-body
                            class="mb-3 border border-secondary shadow-none">
                      <b-card-header class="bg-secondary" header-tag="header">
                        <h6 class="m-0 text-white">
                          {{ d.cnpj | VMask('##.###.###/####-##') }} |
                          {{ d.mun_codigo.mun_nome + ' - ' + d.mun_codigo.mun_uf }}
                        </h6>
                      </b-card-header>
                      <b-card-body>
                        <b-card-text>
                          <h6>Receita por atividade</h6>
                          <div v-if="d.atividades && d.atividades.length === 0">
                            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-warning">
                              <i class="mdi mdi-alert-outline mr-2"></i> Filial sem nenhuma atividade informada no
                              período
                            </div>
                          </div>
                          <div v-else class="border border-secondary mb-3 p-2" v-for="a in d.atividades"
                               v-bind:key="a.atividade">
                            <h6 class="mt-1 mb-3"><i class="mdi mdi-card-account-details-outline"></i>
                              {{ a.atividade }} - {{ a.atividade | ativiadeSimples }}
                            </h6>
                            <div class="row">
                              <div class="col-sm-6 mb-2">
                                <div
                                    class="rounded d-flex flex-column justify-content-between align-items-center pt-4 pb-4 alert-secondary">
                                  <div class="text-muted">Valor Total da Receita</div>
                                  <div class="text-dark pt-2 pr-3 pb-2 pl-3 rounded">
                                    <strong>{{ a.valor | formatNumeroBr }}</strong></div>
                                </div>
                              </div>
                              <div class="col-sm-6">
                                <div
                                    class="rounded d-flex flex-column justify-content-between align-items-center pt-4 pb-4 alert-secondary">
                                  <div class="text-muted">Valor Total dos tributos</div>
                                  <div class="text-dark pt-2 pr-3 pb-2 pl-3 rounded">
                                    <strong>{{ a.valor_imposto | formatNumeroBr }}</strong></div>
                                </div>
                              </div>
                            </div>
                            <div v-for="(ra, index) in a.receita_atividade" v-bind:key="index">
                              <h6 class="mt-3"><i class="mdi mdi-currency-usd"></i> Valor devido por tributo</h6>
                              <div class="row">
                                <div class="col-sm-2">
                                  <div
                                      class="m-1 rounded d-flex flex-column justify-content-between align-items-center pt-4 pb-4 alert-secondary">
                                    <div class="text-muted">COFINS</div>
                                    <div class="text-dark pt-2 pr-3 pb-2 pl-3 rounded">
                                      <strong>{{ ra.vlconfis | formatNumeroBr }}</strong></div>
                                  </div>
                                </div>
                                <div class="col-sm-2">
                                  <div
                                      class="m-1 rounded d-flex flex-column justify-content-between align-items-center pt-4 pb-4 alert-secondary">
                                    <div class="text-muted">CSLL</div>
                                    <div class="text-dark pt-2 pr-3 pb-2 pl-3 rounded">
                                      <strong>{{ ra.vlcsll | formatNumeroBr }}</strong></div>
                                  </div>
                                </div>
                                <div class="col-sm-2">
                                  <div
                                      class="m-1 rounded d-flex flex-column justify-content-between align-items-center pt-4 pb-4 alert-secondary">
                                    <div class="text-muted">ICMS</div>
                                    <div class="text-dark pt-2 pr-3 pb-2 pl-3 rounded">
                                      <strong>{{ ra.vlicms | formatNumeroBr }}</strong></div>
                                  </div>
                                </div>
                                <div class="col-sm-2">
                                  <div
                                      class="m-1 rounded d-flex flex-column justify-content-between align-items-center pt-4 pb-4 alert-secondary">
                                    <div class="text-muted">INSS</div>
                                    <div class="text-dark pt-2 pr-3 pb-2 pl-3 rounded">
                                      <strong>{{ ra.vlinss | formatNumeroBr }}</strong></div>
                                  </div>
                                </div>
                                <div class="col-sm-2">
                                  <div
                                      class="m-1 rounded d-flex flex-column justify-content-between align-items-center pt-4 pb-4 alert-secondary">
                                    <div class="text-muted">IPI</div>
                                    <div class="text-dark pt-2 pr-3 pb-2 pl-3 rounded">
                                      <strong>{{ ra.vlipi | formatNumeroBr }}</strong></div>
                                  </div>
                                </div>
                                <div class="col-sm-2">
                                  <div
                                      class="m-1 rounded d-flex flex-column justify-content-between align-items-center pt-4 pb-4 alert-secondary">
                                    <div class="text-muted">IRPJ</div>
                                    <div class="text-dark pt-2 pr-3 pb-2 pl-3 rounded">
                                      <strong>{{ ra.vlirpj | formatNumeroBr }}</strong></div>
                                  </div>
                                </div>
                                <div class="col-sm-2">
                                  <div
                                      class="m-1 rounded d-flex flex-column justify-content-between align-items-center pt-4 pb-4 alert-secondary">
                                    <div class="text-muted">ISS</div>
                                    <div class="text-dark pt-2 pr-3 pb-2 pl-3 rounded">
                                      <strong>{{ ra.valor_iss | formatNumeroBr }}</strong></div>
                                  </div>
                                </div>
                                <div class="col-sm-2">
                                  <div
                                      class="m-1 rounded d-flex flex-column justify-content-between align-items-center pt-4 pb-4 alert-secondary">
                                    <div class="text-muted">ALIQUOTA ISS</div>
                                    <div class="text-dark pt-2 pr-3 pb-2 pl-3 rounded">
                                      <strong>{{ (ra.aliq_iss * 100) }}%</strong></div>
                                  </div>
                                </div>
                                <div class="col-sm-2">
                                  <div
                                      class="m-1 rounded d-flex flex-column justify-content-between align-items-center pt-4 pb-4 alert-secondary">
                                    <div class="text-muted">PIS</div>
                                    <div class="text-dark pt-2 pr-3 pb-2 pl-3 rounded">
                                      <strong>{{ ra.vlpis | formatNumeroBr }}</strong></div>
                                  </div>
                                </div>
                                <div class="col-sm-2">
                                  <div
                                      class="m-1 rounded d-flex flex-column justify-content-between align-items-center pt-4 pb-4 alert-secondary">
                                    <div class="text-muted">TOTAL</div>
                                    <div class="text-dark pt-2 pr-3 pb-2 pl-3 rounded">
                                      <strong>{{ ra.vlimposto | formatNumeroBr }}</strong></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </b-card-text>
                      </b-card-body>
                    </b-card>
                  </div>
                </div>
              </b-card-text>
            </b-card-body>
          </b-card>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm-12">
          <b-card no-body class="mb-1 border border-info shadow-none">
            <b-card-header class="bg-info" header-tag="header">
              <h6 class="m-0 text-white">
                Discriminação dos Valores Calculados
              </h6>
            </b-card-header>
            <b-card-body>
              <b-card-text>
                <div v-for="(ds, index) in declaracao.das" v-bind:key="index" class="row">
                  <div class="col-sm-12 text-left">
                    <h6 class="mb-3">Informações sobre DAS</h6>
                  </div>
                  <dl class="col-sm-6">
                    <dt class="text-dark">Número</dt>
                    <dd>{{ ds.guia }}</dd>
                  </dl>
                  <dl class="col-sm-6">
                    <dt class="text-dark">Valor</dt>
                    <dd>{{ ds.total | formatNumeroBr }}</dd>
                  </dl>
                  <dl class="col-sm-6">
                    <dt class="text-dark">Emissão</dt>
                    <dd>{{ ds.data_emissao | removeHour | formatDataSimples }}</dd>
                  </dl>
                  <dl class="col-sm-6">
                    <dt class="text-dark">Vencimento</dt>
                    <dd>{{ ds.vencimento | formatDataSimples }}</dd>
                  </dl>
                  <div class="col-sm-12">
                    <table class="table">
                      <thead>
                      <tr>
                        <th scope="col">Tributo</th>
                        <th scope="col">Valor</th>
                        <th scope="col">Unidade Arrecadadora</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(de, index) in ds.detalhe" v-bind:key="index">
                        <td>{{ de.cod_receita | receitasSimplesNacional }}</td>
                        <td>{{ de.valor | formatNumeroBr }}</td>
                        <td>{{ de | uaSimples }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-card-text>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row mt-3">
        <div class="col-sm-12">
          <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-warning">
            <i class="mdi mdi-alert-outline mr-2"></i> Não foi localizada análise de DAS-D para o período de apuração
            informado
          </div>
        </div>
      </div>
    </div>
  </Loader>
</template>

<script>
import Loader from "../../../../../components/widgets/loader";
import {getDeclaracaoSimples} from "../../../../../api/simples_nacional/declaracao";

export default {
  name: "simplesDas",
  components: {
    Loader,
  },
  props: {
    eco_codigo: {
      type: String,
      required: true,
    },
    competencia: {
      type: String,
      required: true,
    },
    pes_cpfcnpj: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      httpSend: false,
      declaracao: {
        periodo: 0
      }
    };
  },
  computed: {
    receita_12meses: {
      get: function () {
        return this.declaracao.receita_mercado_interno
            .map(p => Number(p.valor))
            .reduce((sum, current) => sum + current, 0);
      }
    },
  },
  methods: {
    list_declaracao() {
      this.httpSend = true;
      getDeclaracaoSimples(this.pes_cpfcnpj, this.competencia).then(result => {
        if (result.dados) {
          this.declaracao = result.dados
        } else {
          this.declaracao.periodo = 0
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
  }
}
</script>

<style scoped>

</style>
